/** Play readers and query keys use the page address without its action suffix. */
export function onePagerAddress(href: string): string {
  return href.replace(/\/play\/?$/, "").slice(1);
}
